export const useApi = (url, options = {}) => {
    const { $api } = useNuxtApp()

    return $api(url, {
        ...options,
        headers: {
            ...options.headers
        }
    })
}

export const apiForClient = {
    get: (url, params = {}, options = {}) => {
        return useApi(url, { ...options, method: 'GET', query: params })
    },
    post: (url, body = {}, options = {}) => {
        return useApi(url, { ...options, method: 'POST', body })
    },
    put: (url, body = {}, options = {}) => {
        return useApi(url, { ...options, method: 'PUT', body })
    },
    delete: (url, options = {}) => {
        return useApi(url, { ...options, method: 'DELETE' })
    }
}
